module.exports = __webpack_public_path__ + "img/association_node.a0be8a8b.svg";